import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(all)/vip/layout.tsx");
